export default {
  path: '/alarms/reminders/:id',
  name: 'ReminderView',
  component: () => import(/* webpackChunkName: "administration" */ '../views/ReminderView.vue')
}
